import {CONTENT_RESIZE} from '../actions/responsive';

export default (state = {
    width: null,
    height: null
}, action) => {
    switch (action.type) {
        case CONTENT_RESIZE:
            state = {...state, ...action.payload};
            break;
    }

    return state;
};
